exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 130px;\n  overflow: hidden;\n  background: white;\n  -webkit-transition: all .3s;\n  transition: all .3s;\n}\n.logo img {\n  width: 59px;\n  height: 58px;\n  margin-left: 55px;\n  margin-top: 36px;\n  margin-bottom: 36px;\n  margin-right: 20px;\n}\n.logo .site-name {\n  margin-top: 40px;\n  margin-bottom: 48px;\n  font-family: 'HiraginoSansGB', sans-serif;\n  font-weight: normal;\n  font-size: 31px;\n  color: #006CB9;\n  text-align: left;\n  font-style: normal;\n  text-transform: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b42dee4","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/components/LayoutLogo/index.vue
// module id = Z3mR
// module chunks = 72